import React from 'react';

/** Lazy ClientComputedHelp (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedHelp = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-help' */
            './ClientComputedHelp'
        ),
);
